import type { AccountInfo } from "../../../../api/account";
import { OtherEmailsRow } from "./OtherEmailsRow";
import { PrimaryEmailRow } from "./PrimaryEmailRow";

/** My account → Profile: the primary email (used to sign in) and the other emails. */
export function EmailsSection({ account, onChanged }: { account: AccountInfo; onChanged: () => void }): React.JSX.Element {
  return (
    <>
      <PrimaryEmailRow account={account} onChanged={onChanged} />
      <OtherEmailsRow account={account} onChanged={onChanged} />
    </>
  );
}
